var _defs, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTrending(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "uuid-65be8dbf-8b7b-4dbd-afe2-be1b67b59f1d",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .uuid-c04eacfd-1731-4195-8dd5-2b99d87ec420 {\n        fill: #f2f2f2;\n      }\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "uuid-c04eacfd-1731-4195-8dd5-2b99d87ec420",
    d: "M22.91,14.99l-1.74-5.92-.99.37s0,0,0,0l-4.53,1.69c-.52.19-.78.77-.59,1.29.19.52.77.78,1.29.59l2.19-.82-2.8,5.86-2.72-3.52-3.89,6.97c-.27.48-.1,1.09.39,1.36.15.09.32.13.49.13.35,0,.69-.18.87-.51l2.41-4.32,2.85,3.69,4.15-8.67.7,2.39c.13.44.53.72.96.72.09,0,.19-.01.28-.04.53-.16.83-.71.68-1.24Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrending);
export default __webpack_public_path__ + "static/media/Trending.74ed8015b8014740c5947c307ceb29a0.svg";
export { ForwardRef as ReactComponent };